module.exports = __webpack_public_path__ + "img/073678.e7065a42.png";